/// <reference path='../../interfaces/interfaces.d.ts' />
import functions = require('../../global/functions');
'use strict';

class AssetManagerController {
    public hasPermission;
    public user;
    public org;
    public schema;
    public employee;
    public showOverlayCallOuts = false;
    public isHelping = false;
    public isTour;

    // callouts
    public isCurrent = -1;

    public canAnnounce = false;

    public selectedAssetTab: number = 0; 
    public newAsset = {
        assetType: '',
        assetSerialNumber: '',
        assetName: '',
        assetCreatedDate: '',
        isAssigned: false,
        isActive: true,
        assetHistory: [],
    };

    public assigned = {
        employeeID: '',
        displayName: '',
        assignDate: '',
        returnDate: '',
    }

    public companyAssets = [];

    public employeeSelectList = [];

    public static $inject = [
        '$scope',
        '$uibModal',
        'User',
        'Employee',
        'Orgs',
        'toaster',
        'bsLoadingOverlayService',
        '$http',
        'Api',
    ];

    constructor(private $scope: angular.IScope,
                private $uibModal: any,
                private User: IUserService,
                private Employee: IEmpService,
                private Orgs: IOrgsService,
                private toaster: toaster.IToasterService,
                private bsLoadingOverlayService: IBsLoadingService,
                private $http: angular.IHttpService,
                private Api: any) {
                    bsLoadingOverlayService.start({referenceId: 'loader'});
                    this.hasPermission = User.hasPermission;
                    this.user = User.getCurrentUser();
                    Orgs.getMyOrg().then((org) => {
                        this.org = org;
                        if (this.org.extra.assets !== undefined) {
                            this.companyAssets = this.org.extra.assets;
                        }


                        Employee.list('').then((response: Restangular.IResponse) => {
                            const tmpEmployees: any = Employee.getObject();
                            for (var h: number = 0; h < tmpEmployees.list.length; h++) {
                                let employee: any = {
                                    id: tmpEmployees.list[h].id,
                                    name: tmpEmployees.list[h].displayname
                                };

                                // list used in the autocomplete dropdown
                                this.employeeSelectList.push(employee);
                            }
                            bsLoadingOverlayService.stop({referenceId: 'loader'});
                        });
                    });

                    Orgs.loadSchema().then((r) => {
                        this.schema = r.data;
                    });


                    Employee.loadEmployee(this.User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
                        this.isTour = this.Employee.getCoTourStatus();
                        this.employee = response;
                    });
        }

        public startCallouts = () => {
            if (this.isHelping) {
                if (this.isTour === true) {
                    this.Employee.setCoTourStatus(false);
                    this.isTour = this.Employee.getCoTourStatus();
                }
                this.isHelping = false;
                this.showOverlayCallOuts = false;
                this.isCurrent = -1;
            } else if (!this.isHelping) {
                this.isHelping = true;
                this.showOverlayCallOuts = true;
                this.isCurrent = 0;
            }
        }

        public nextCallout (params: any): any {
        
            if (this.canAnnounce === true && params === 'canAnnounce') {
            } else if (this.canAnnounce === false) {
                this.isCurrent = this.isCurrent + 1;
            } else if (params === 'all') {
                this.isCurrent = this.isCurrent + 1;   
            } else {
                this.isCurrent = this.isCurrent + 1;
            }
        } 

        public selectAssetTab = (tab: number) => {
            this.selectedAssetTab = tab;
        };

        public myAssets = () => {
            const currentUser = this.user.userData.id;
            const myAssets = [];
            this.companyAssets.forEach((asset) => {
                asset.assetHistory.forEach((history) => {
                    if (history.employeeID === currentUser && asset.isActive && (history.returnDate === '')) {
                        myAssets.push(asset);
                    }
                })
            });
            return myAssets;
        };

        public assetTable = (table: string, permission: string) => {
            return table === 'org_assets' && this.User.hasPermission(permission) ? true : false;
        };

        public orgAssets = () => {
            const currentUser = '123';
            const orgAssets = [];
            this.companyAssets.forEach((asset) => {
                if (asset.isActive) {
                    orgAssets.push(asset)
                }
            });
            return orgAssets;
        };

        public viewAssetHistory = (asset: any[]) => {
            const that: any = this;
            let modalInstance: any = this.$uibModal.open({
                controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                    $scope.model = asset.sort((a, b) => new Date(b.assignDate).getTime() - new Date(a.assignDate).getTime());
                    $scope.close = () => {
                        $uibModalInstance.close($scope.model);
                    }
                }],

                templateUrl: '/static/templates/modals/asset_history_modal.html'
            });
        }

        public addAsset = () => {
            this.newAsset = {
                assetType: '',
                assetSerialNumber: '',
                assetName: '',
                assetCreatedDate: '',
                isAssigned: false,
                isActive: true,
                assetHistory: [],
            };
            const that: any = this;
            let modalInstance: any = this.$uibModal.open({
                controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                    $scope.C = that;
                    $scope.model = that.newAsset;
                    $scope.add = () => {
                        const index = that.companyAssets.findIndex((asset) => asset.assetSerialNumber === that.newAsset.assetSerialNumber);
                        if (index !== -1) { 
                            that.toaster.pop(
                                'warning',
                                'Warning',
                                'A asset with that serial number already exists.'
                            );
                            $uibModalInstance.close($scope.model);
                            return;
                        } else {
                            that.companyAssets.push(that.newAsset);
                            that.saveOrgAsset();
                            $uibModalInstance.close($scope.model);
                        }
                    };
                }],

                templateUrl: '/static/templates/modals/asset_add_modal.html'
            });
        };

        public editAsset = (assetToEdit: any) => {
            const that: any = this;
            let modalInstance: any = this.$uibModal.open({
                controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                    $scope.model = assetToEdit;
                    $scope.add = () => {
                        const index = that.companyAssets.findIndex((asset) => asset.assetSerialNumber === assetToEdit.assetSerialNumber);
                        that.companyAssets[index] = assetToEdit;
                        that.saveOrgAsset();
                        $uibModalInstance.close($scope.model);
                    }
                }],

                templateUrl: '/static/templates/modals/asset_edit_modal.html'
            });
        };

        public deleteAsset = (assetToDelete: any) => {
            const that: any = this;
            let modalInstance: any = this.$uibModal.open({
                controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                    $scope.model = assetToDelete;
                    $scope.delete = () => {
                        const index = that.companyAssets.findIndex((asset) => asset.assetSerialNumber === assetToDelete.assetSerialNumber);
                        that.companyAssets[index].isActive = false;
                        that.saveOrgAsset();
                        $uibModalInstance.close($scope.model);
                    }
                }],

                templateUrl: '/static/templates/modals/asset_delete_modal.html'
            });
        };

        public returnAsset = (assetToReturn: any) => {
            const that: any = this;
            let modalInstance: any = this.$uibModal.open({
                controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                    $scope.model = assetToReturn;
                    $scope.return = () => {
                        $uibModalInstance.close($scope.model);
                        const assetIndex = that.companyAssets.findIndex((asset) => asset.assetSerialNumber === assetToReturn.assetSerialNumber);
                        const assignedIndex = assetToReturn.assetHistory
                            .findIndex((history) => history.returnDate === undefined || history.returnDate === '');
                        that.companyAssets[assetIndex].assetHistory[assignedIndex].returnDate = new Date($scope.model.assetReturnDate).toISOString();
                        that.saveOrgAsset();
                    }
                }],

                templateUrl: '/static/templates/modals/asset_return_modal.html'
            });
        };

        public assignAsset = (assetToAssign: any) => {
            const that: any = this;
            let modalInstance: any = this.$uibModal.open({
                controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                    $scope.C = that;
                    $scope.model = assetToAssign;
                    $scope.add = () => {
                        const index = that.companyAssets.findIndex((asset) => asset.assetSerialNumber === assetToAssign.assetSerialNumber);
                        const { 
                            assignDate, 
                            assignedEmployee: {
                                id = '',
                                name = '',
                            } = {},
                        } = assetToAssign;
                        that.assigned = {
                            employeeID: id,
                            displayName: name,
                            assignDate: assignDate,
                            returnDate: '',
                        }
                        that.companyAssets[index].assetHistory.push(that.assigned);
                        that.saveOrgAsset();
                        $uibModalInstance.close($scope.model);
                    };
                }],

                templateUrl: '/static/templates/modals/asset_assign_modal.html'
            });
        };

        public checkIfAssetIsAssigned = (assetHistory: object[]): boolean => { 
            if (assetHistory === undefined) {
                return false;
            }
            const assigned = assetHistory.map((history: any) => {
                return history.returnDate === '' ? history : null;
            }).filter((notNull) => notNull);
            return assigned.length > 0;
        };

        public saveOrgAsset = (): void => {
            if (this.org.extra.assets === undefined) {
                this.org.extra.assets = [];
            }
            this.org.extra.assets = this.companyAssets;
            this.bsLoadingOverlayService.start({referenceId: 'loader'});
            let url: any ='/api/org';
            this.$http.put(url, this.Api.stripRestangular(this.org)).then((org) => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.myAssets();
            }, (response: any) => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                if (response.status === 403) {
                    this.toaster.pop('error', 'Access Denied', response.data.detail);
                } else if (response.status === 400) {
                    this.toaster.pop('error', 'Asset not saved', response.data[0] || response.data);
                } else {
                    this.toaster.pop('error', 'Server error', 'Please, try again later');
                }
            });
        }

        
}

angular.module('beneple.assets')
    .controller('AssetManagerController', AssetManagerController);


// WEBPACK FOOTER //
// ./frontend/scripts/assets/controllers/assetsController.ts